// extracted by mini-css-extract-plugin
export var card = "_6k-0";
export var expandedCard = "_6k-2";
export var paginated = "_6k-1";